/* intl-provider.tsx generated by @compiled/babel-plugin v0.40.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1j4a%7Bwidth%3A130px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i19bv%7Bheight%3A10px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkizff%7Bbackground-color%3Avar(--ds-skeleton%2C%230515240f)%7D");
import React, { useEffect, useState } from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { NAVIGATION_CHANNEL } from '../../common/utils/analytics';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Box } from '@atlaskit/primitives/compiled';
import messages from '../primitives/messages';
type MessageFile = {
  default: {
    [key: string]: string;
  };
};
const styles = {
  skeleton: "_2rko12b0 _1e0c1o8l _1bsb1j4a _4t3i19bv _bfhkizff"
};
function fetchLanguageFile(locale: string): Promise<MessageFile> {
  switch (locale) {
    case 'cs-CZ':
    case 'cs':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-cs" */'../../i18n/cs');
    case 'da-DK':
    case 'da':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-da" */'../../i18n/da');
    case 'de-DE':
    case 'de':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-de" */'../../i18n/de');
    case 'en-GB':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-en-GB" */'../../i18n/en_GB');
    case 'en-ZZ':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-en-ZZ" */'../../i18n/en_ZZ');
    case 'en-US':
    case 'en':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-en" */'../../i18n/en');
    case 'es-ES':
    case 'es':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-es" */'../../i18n/es');
    case 'et':
      {
        return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-et" */'../../i18n/et');
      }
    case 'fi-FI':
    case 'fi':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-fi" */'../../i18n/fi');
    case 'fr-FR':
    case 'fr':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-fr" */'../../i18n/fr');
    case 'hu-HU':
    case 'hu':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-hu" */'../../i18n/hu');
    case 'is':
      {
        return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-is" */'../../i18n/is');
      }
    case 'it-IT':
    case 'it':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-it" */'../../i18n/it');
    case 'ja-JP':
    case 'ja':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-ja" */'../../i18n/ja');
    case 'ko-KR':
    case 'ko':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-ko" */'../../i18n/ko');
    case 'nb-NB':
    case 'nb':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-nb" */'../../i18n/nb');
    case 'nl-NL':
    case 'nl':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-nl" */'../../i18n/nl');
    case 'pl-PL':
    case 'pl':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-pl" */'../../i18n/pl');
    case 'pt-BR':
    case 'pt':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-pt-BR" */'../../i18n/pt_BR');
    case 'pt-PT':
      {
        return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-pt-PT" */'../../i18n/pt_PT');
      }
    case 'ro':
      {
        return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-ro" */'../../i18n/ro');
      }
    case 'ru-RU':
    case 'ru':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-ru" */'../../i18n/ru');
    case 'sk':
      {
        return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-sk" */'../../i18n/sk');
      }
    case 'sv-SE':
    case 'sv':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-sv" */'../../i18n/sv');
    case 'th-TH':
    case 'th':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-th" */'../../i18n/th');
    case 'tr-TR':
    case 'tr':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-tr" */'../../i18n/tr');
    case 'uk-UK':
    case 'uk':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-uk" */'../../i18n/uk');
    case 'vi-VI':
    case 'vi':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-vi" */'../../i18n/vi');
    case 'zh-TW':
    case 'zh-HK':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-zh-TW" */'../../i18n/zh_TW');
    case 'zh-ZH':
    case 'zh-CN':
    case 'zh':
      return import( /* webpackChunkName: "@atlaskit-internal_async-atlassian-switcher-i18n-zh-ZH" */'../../i18n/zh');
  }
  throw Error(`Unable to find translation for locale ${locale}`);
}
interface SwitcherIntlProviderProps {
  children: React.ReactNode;
}
const SwitcherIntlProvider = ({
  children
}: SwitcherIntlProviderProps): React.JSX.Element => {
  const {
    locale,
    formatMessage
  } = useIntl();
  // Intl.Locale doesn't like underscores
  const [isLocaleLoaded, setIsLocaleLoaded] = useState(false);
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const [localeMessages, setLocaleMessages] = useState({});
  useEffect(() => {
    async function startToFetchMessagesByLocale() {
      const intlLocale = new Intl.Locale(locale.replace('_', '-'));
      try {
        const module = await fetchLanguageFile(intlLocale.toString());
        const newMessages = module.default || module;
        setLocaleMessages(newMessages);
        setIsLocaleLoaded(true);
      } catch {
        // fail to download message and do nothing because UI will use default language (English) to render
        setIsLocaleLoaded(true);
        createAnalyticsEvent({
          eventType: OPERATIONAL_EVENT_TYPE,
          action: 'not_loaded',
          actionSubject: 'i18n',
          attributes: {
            country: intlLocale.region,
            language: intlLocale.language
          }
        }).fire(NAVIGATION_CHANNEL);
      }
    }
    startToFetchMessagesByLocale();
  }, [locale, createAnalyticsEvent]);

  // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
  if (!isLocaleLoaded) {
    return <Box role="status" xcss={styles.skeleton} aria-label={formatMessage(messages.skeletonLoaderAriaLabel)} />;
  }
  return <IntlProvider locale={locale} key={locale} messages={localeMessages}>
			{children}
		</IntlProvider>;
};
export default SwitcherIntlProvider;